module.exports = {};



//////////////////
// WEBPACK FOOTER
// /Users/sandersturing/Sites/SD/dudok.test/frontend/node_modules/babel-polyfill/node_modules/core-js/modules/_iterators.js
// module id = 46
// module chunks = 0